<template>
  <div :class="playerClass">
    <div class="videoWrapper">
      <div id="kaltura-player"></div>
    </div>
    <a @click.prevent="playVideo(currentPlayer)" class="videoBtn">
      <img
        v-if="imgPath"
        :src="imgPath"
        :alt="video.pagetitle"
        class="img-responsive"
      />
      <div class="play-icon">
        <img
          src="../../assets/images/play-icon-big.png"
          alt="נגן סרטון"
          v-if="!showSpinner"
        />
        <load-spinner v-show="showSpinner"></load-spinner>
      </div>
    </a>
    <transition name="fade">
      <video-overlay
        :video="video"
        :state="playerState"
        :player="currentPlayer"
        :nextSeries="nextSeries"
        v-if="showOverlay"
        v-on:load-next="$emit('load-next')"
        :isLast="isLast"
      ></video-overlay>
    </transition>
  </div>
</template>

<script>
// import KalturaPlayer from "KalturaPlayer";
import LoadSpinner from "@/components/LoadSpinner.vue";
import VideoOverlay from "./VideoOverlay2.vue";

export default {
  name: `MainVideo`,
  props: {
    video: Object,
    base: String,
    isLast: {
      type: Boolean,
      default: false,
    },
    nextSeries: Number,
  },
  components: {
    LoadSpinner,
    VideoOverlay,
  },
  data() {
    return {
      showSpinner: false,
      imgPath: ``,
      playerClass: `main-video`,
      currentPlayer: {
        destroy: () => {},
      },
      playerState: {
        loading: true,
        paused: false,
        ended: false,
        location: 0,
      },
    };
  },
  watch: {
    video() {
      this.playerClass = `main-video`;
      this.currentPlayer.destroy();
      this.playerState.paused = false;
      this.playerState.ended = false;
      this.imgPath = `${this.base}assets/yoga/images/videos/${this.video.videoImg}`;
      this.loadVideo();
    },
  },
  beforeUpdate() {
    if (this.video.videoImg) {
      this.imgPath = `${this.base}assets/yoga/images/videos/${this.video.videoImg}`;
    }
  },

  mounted() {
    if (this.video.videoImg) {
      this.imgPath = `${this.base}assets/yoga/images/videos/${this.video.videoImg}`;

      this.loadVideo();
    }
  },

  methods: {
    loadVideo() {
      this.showSpinner = true;
      try {
        var player = KalturaPlayer.setup({
          targetId: "kaltura-player",
          provider: {
            partnerId: 2942911,
            uiConfId: 46099891,
            ks: this.video.ks,
          },
          playback: {
            autoplay: false,
          },
        });
        player.loadMedia({ entryId: this.video.kalturaId });
        player.ready().then((this.showSpinner = false));
      } catch (e) {
        console.error(e.message);
      }
      this.currentPlayer = player;
      player.addEventListener(player.Event.PLAYER_STATE_CHANGED, event => {
        const newState = event.payload.newState;
        console.log("New state type is: " + newState.type);

        if (newState.type === "loading") {
          this.playerState.loading = true;
        } else {
          this.playerState.loading = false;
        }

        if (newState.type === "playing") {
          this.playerState.paused = false;
          this.playerState.ended = false;
          this.playVideo();
          this.playerState.location = player.currentTime / player.duration;
        }

        if (newState.type === "paused") {
          this.playerState.paused = true;
          this.playerState.location = player.currentTime / player.duration;
        }

        if (newState.type === "idle") {
          this.playerState.paused = false;
          this.playerState.ended = true;
          this.playerState.location = player.currentTime / player.duration;
          this.$emit(`video-ended`);
        }
      });
    },

    playVideo(player) {
      this.showSpinner = true;
      this.currentPlayer.play();
      this.$store.dispatch(`addToHistory`, this.video.id);
      this.$store.dispatch(`saveExtendedHistory`, this.video.id);
      this.playerClass = `main-video video-playing`;
    },
  },

  computed: {
    showOverlay() {
      if (
        this.playerState.ended ||
        (this.playerState.paused && this.playerState.location !== 0) ||
        this.playerState.loading
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style>
.playkit-player {
  padding-bottom: 56.25%;
}
</style>
